import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import {
  weActiveSponsorshipsData,
  weUserImage
} from 'data/weraise-data/donar-data';
import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import DonorSponsorshipModal from './modals/DonorSponsorshipModal';

const DonorSponsorships = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [showSponsorship, setShowSponsorship] = useState(false);
  const [sponsorshipId, setSponsorshipId] = useState('');
  return (
    <>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="mt-2 fw-bold">Sponsorships</h4>}
          light={false}
          titleTag="div"
          menuClassName="align-items-center"
          endEl={
            <IconButton
              onClick={() => navigate(`/donors/${id}/sponsor`)}
              icon="link"
              transform="shrink-3"
            >
              <span className="d-none d-md-inline-block ms-2">Sponsor</span>
            </IconButton>
          }
        />
      </Card>
      <Card className="mb-3">
        <Card.Header>
          <Flex
            justifyContent={'between'}
            alignItems="center"
            className="flex-column flex-md-row"
          >
            <Form.Group
              as={Flex}
              className="align-items-start align-items-md-center w-100 w-md-50 flex-column flex-md-row mb-3 mb-md-0"
              controlId="active_sponsorships"
            >
              <Form.Label
                className="mb-2 mb-md-0 me-3"
                style={{ minWidth: 'fit-content' }}
              >
                Active Sponsorships
              </Form.Label>

              <Form.Control type="text" placeholder="Search" />
            </Form.Group>

            <div>
              <IconButton
                size="sm"
                icon={'filter'}
                variant="falcon-default"
                className="me-3"
                iconClassName={'me-1'}
              >
                Filter
              </IconButton>
              <IconButton
                size="sm"
                icon={'external-link-alt'}
                iconClassName={'me-1'}
                variant="falcon-default"
              >
                Export
              </IconButton>
            </div>
          </Flex>
        </Card.Header>
      </Card>
      {weActiveSponsorshipsData?.map(user => (
        <Card className="mb-3" key={user.id}>
          <FalconCardHeader
            title={
              <div className="align-items-md-center d-md-flex">
                <p className="fw-medium text-900 mb-0">{user.title}</p>
                <IconButton
                  icon="edit"
                  variant="link"
                  className="text-400"
                  transform="shrink-3"
                />
                {user.status?.map(item => (
                  <SoftBadge
                    key={item.id}
                    pill
                    bg={item.bg}
                    className="me-2 text-uppercase"
                  >
                    {item.label}
                  </SoftBadge>
                ))}
              </div>
            }
            light={false}
            titleTag="div"
            className="py-2"
            menuClassName="align-items-center"
            endEl={
              <IconButton
                icon="pen"
                variant="link"
                className="text-800 p-0 lh-1"
                transform="shrink-3"
                onClick={() =>
                  navigate(`/donors/${id}/sponsor/from/${user.id}`)
                }
              />
            }
          />
          <Card.Body className="pt-0">
            <div className="d-md-flex justify-content-between">
              <div className="d-flex align-items-center mt-2 mt-md-0">
                <div>
                  <Avatar src={weUserImage} size="3xl" />
                </div>
                <div className="ms-2">
                  <p className="fw-medium mb-2 text-900">{user.name}</p>
                  <Flex alignItems={'center'} className="flex-wrap">
                    <p className="me-2 mb-0 fs--2 text-600">
                      <FontAwesomeIcon
                        icon={'map-marker-alt'}
                        className="me-1 fs--1 text-800"
                      />
                      {user.location}
                    </p>
                    <p className="me-2 mb-0 fs--2 text-600">
                      <FontAwesomeIcon
                        icon={'fa-bullhorn'}
                        className="me-1 fs--1 text-800"
                      />
                      {user.reminder}
                    </p>
                    <p className="me-2 mb-0 fs--2 text-600">
                      <FontAwesomeIcon
                        icon={'calendar-alt'}
                        className="me-1 fs--1 text-800"
                      />
                      {user.date}
                    </p>
                    <p className="me-2 mb-0 fs--2 text-600">
                      <FontAwesomeIcon
                        icon={'money-bill'}
                        className="me-1 fs--1 text-800"
                      />
                      {user.amount}
                    </p>
                  </Flex>
                </div>
              </div>
              <Button
                onClick={() => {
                  setShowSponsorship(true);
                  setSponsorshipId(user.id);
                }}
                variant="falcon-default align-self-end mt-2 mt-md-0"
              >
                View Sponsorship
              </Button>
            </div>
          </Card.Body>
        </Card>
      ))}

      <DonorSponsorshipModal
        setModalShow={setShowSponsorship}
        modalShow={showSponsorship}
        editPath={() => navigate(`/donors/${id}/sponsor/from/${sponsorshipId}`)}
      />
    </>
  );
};

export default DonorSponsorships;
